"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageMetric = void 0;
var PageMetric;
(function (PageMetric) {
    PageMetric["ActivityRate"] = "activityRate";
    PageMetric["BounceRate"] = "bounceRate";
    PageMetric["ConversionRate"] = "conversionRate";
    PageMetric["ElapsedTime"] = "elapsedTime";
    PageMetric["ExitRate"] = "exitRate";
    PageMetric["FoldHeight"] = "foldHeight";
    PageMetric["InteractionTime"] = "interactionTime";
    PageMetric["LandingRate"] = "landingRate";
    PageMetric["LargestContentfulPaint"] = "largestContentfulPaint";
    PageMetric["LoadingTime"] = "loadingTime";
    PageMetric["PageHeight"] = "pageHeight";
    PageMetric["ScrollRate"] = "scrollRate";
    PageMetric["TransformationRate"] = "transformationRate";
    PageMetric["UniqueVisits"] = "uniqueVisits";
    PageMetric["Views"] = "views";
    PageMetric["ViewsVisits"] = "viewsVisits";
    PageMetric["VisitRate"] = "visitRate";
    PageMetric["Visits"] = "visits";
})(PageMetric = exports.PageMetric || (exports.PageMetric = {}));
//# sourceMappingURL=pages.metrics.model.js.map